import React from 'react';
import { classes } from '@bloomberg/media-ui-core';

import { defaultMessages, LABEL_KEYS, useTranslateMessage } from '../i18n';

import styles from './styles.module.css';

export const OrSeparator = (props: { theme: 'light' | 'dark' }) => {
  const translateMessage = useTranslateMessage();
  const orTranslated = translateMessage({
    id: LABEL_KEYS['media-ui-login_orSeparator'],
    defaultMessage: defaultMessages['media-ui-login_orSeparator'],
  });

  return (
    <div className={styles.separatorRow}>
      <div className={styles.separatorItem}>
        <hr />
      </div>
      <div
        className={classes([
          styles.separatorItem,
          { [styles.textWhite]: props.theme === 'dark' },
        ])}
      >
        <span>{orTranslated}</span>
      </div>
      <div className={styles.separatorItem}>
        <hr />
      </div>
    </div>
  );
};
